import { render, staticRenderFns } from "./ScoreCardFullScreenTable.vue?vue&type=template&id=5165cb8b&"
import script from "./ScoreCardFullScreenTable.vue?vue&type=script&lang=js&"
export * from "./ScoreCardFullScreenTable.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardFullScreenTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports